import React, { useEffect, useRef, memo, useState } from 'react';

import Typewriter from 'typewriter-effect/dist/core';

/**
 *  answerCallback 打字完成的回调
 *  controlStop 是否停止打字
 *  startCallback 开始打字的回调 为了展示出来暂停回答的按钮
 *  stopCallback 停止打字的回调
 */

export default memo(
  ({
    node = '',
    answerCallback = () => {},
    controlStop = false,
    startCallback = () => {},
    stopCallback = () => {}
  }) => {
    const showNode = useRef(null);
    const [tNode, setTNode] = useState(null);
    // const [s, setS] = useState(0);

    useEffect(() => {
      let typewriter = new Typewriter(showNode.current, {
        delay: 0
      });

      setTNode(typewriter.typeString(node));
    }, []);

    // 隐藏光标
    const disableCursor = () => {
      let cursorDom = document.querySelectorAll('.Typewriter__cursor');
      for (let i = 0; i < cursorDom.length; i++) {
        cursorDom[i].style.display = 'none';
      }
    };

    useEffect(() => {
      if (node && tNode) {
        startCallback();
        tNode.start().callFunction(() => {
          // 回调函数知道什么时候打字结束
          answerCallback();
          disableCursor();
        });
      }
    }, [node, tNode]);

    // 获取当前暂停打字以后的innerHTML
    const getInnerHTML = () => {
      let backObj = {
        tip: '',
        title: '',
        softList: []
      }; // 最后返回的对象
      let softList = []; // 当前的应用信息
      let chatTipList = showNode.current.querySelectorAll('#chat_tip'); //当前消息
      if (chatTipList?.length > 0) {
        for (let i = 0; i < chatTipList?.length; i++) {
          backObj.tip = chatTipList[i].innerHTML;
        }
      }
      let chatSoftList = showNode.current.querySelectorAll('.info_soft_item_w'); //当前应用列表
      if (chatSoftList?.length > 0) {
        for (let a = 0; a < chatSoftList?.length; a++) {
          softList.push({ pauseDesc: chatSoftList[a].innerText });
        }
      }
      let chatTitle = showNode.current.querySelectorAll('.info_title'); // 当前的标题
      if (chatTitle?.length > 0) {
        for (let k = 0; k < chatTitle?.length; k++) {
          backObj.title = chatTitle[k].innerHTML;
        }
      }
      backObj = {
        ...backObj,
        appList: softList
      };
      return backObj;
    };

    useEffect(() => {
      if (controlStop && tNode) {
        tNode.stop();
        answerCallback();
        disableCursor();
        stopCallback(getInnerHTML());
      }
    }, [controlStop, tNode]);

    return <div ref={showNode} />;
  }
);
